import { render, staticRenderFns } from "./ProvinceCommon.vue?vue&type=template&id=75fd712a"
import script from "./ProvinceCommon.vue?vue&type=script&lang=js"
export * from "./ProvinceCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports